/*
 * Carga condicional de la segunda imagen (hover) de las tarjetas de producto.
 *
 * card-product.liquid emite esa imagen con data-srcset / data-src, de modo que el
 * navegador no la descarga por su cuenta. Aca le devolvemos los atributos reales
 * solo en dispositivos donde el efecto hover existe.
 *
 * La media query replica la de component-card.css: el efecto solo se activa desde
 * 990px y con un puntero capaz de hover. En mobile y tablet esto elimina una
 * descarga por producto, que es el objetivo.
 *
 * Por que se activan al cargar y no en el evento hover: el CSS oculta la primera
 * imagen y revela la segunda en el mismo instante en que entra el puntero. Si la
 * descarga arranca recien ahi, se ve la tarjeta en blanco mientras baja el archivo.
 * Activandolas antes, el atributo loading="lazy" que ya traen sigue difiriendo las
 * que estan fuera de viewport: el comportamiento en desktop queda igual que antes.
 */
(function () {
  'use strict';

  var mediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');

  function activateWithin(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    var images = root.querySelectorAll('.card__hover-image[data-srcset]');
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      // srcset antes que src, para que el navegador resuelva el candidato correcto
      // de una sola vez en lugar de pedir primero el fallback.
      image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
    }
  }

  function activateDocument() {
    if (!mediaQuery.matches) return;
    activateWithin(document);
  }

  activateDocument();

  // Las tarjetas se inyectan dinamicamente al filtrar (facets.js) y al paginar
  // (infinite-scroll.liquid), asi que hay que atender lo que llegue despues.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      if (!mediaQuery.matches) return;

      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) activateWithin(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Al agrandar la ventana se puede cruzar el umbral de 990px sin recargar.
  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', activateDocument);
  } else if (typeof mediaQuery.addListener === 'function') {
    mediaQuery.addListener(activateDocument);
  }
})();
